import BaseSerializer from './Base';
import ImageWMS from 'ol/source/ImageWMS';
import {isArray} from '@config/utils';

class ImageWMSSerializer extends BaseSerializer {
    constructor() {
        super();
        this.sourceCls = ImageWMS;
    }

    serialize(layer, source) {
        this.validateSource(source);
        let styles = source.getParams().STYLES;
        let stylesArray;
        if (isArray(styles)) {
            stylesArray = styles;
        } else {
            stylesArray = styles ? styles.split(',') : [''];
        }
        let serialized = {
            baseURL: source.getUrl(),
            customParams: source.getParams(),
            layers: [
                source.getParams().LAYERS
            ],
            opacity: layer.getOpacity(),
            styles: stylesArray,
            type: 'WMS'
        };
        return serialized;
    }
};

export default ImageWMSSerializer;